import {KnowledgeRAGResponse} from 'common/src/modules/ai/ai.types';
import formatDecimalAsPercentage from 'common/src/utils/numberUtils/formatDecimalAsPercentage';

function formatRawResources(response: KnowledgeRAGResponse): string {
  if (!response.resources || response.resources.length === 0) {
    return 'No resources found.';
  }

  const parts: string[] = ['Resources:'];

  const resourcesJson = JSON.stringify(
    response.resources.map((resource) => ({
      title: resource.title,
      relevancyScore: formatDecimalAsPercentage(resource.relevancyScore),
      content: resource.content,
      ...(resource.url && {url: resource.url}),
    })),
    null,
    2,
  );
  parts.push(`\n${resourcesJson}`);

  if (response.issues) {
    parts.push(`\n\nIssues: ${response.issues}`);
  }

  return parts.join('\n');
}

export default formatRawResources;
